module.exports = __webpack_public_path__ + "ac63818cd484a24abf5c33885998d80a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WW-AFR.svg
// module id = 12au
// module chunks = 0